<template lang="pug" src="./finances.pug"></template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(['roleName']),
    }
};
</script>
